document.addEventListener("DOMContentLoaded", function () {
  // scroll is still position
  var scroll = document.documentElement.scrollTop || document.body.scrollTop;
  var header = document.querySelector(".sorta_header");
  var headerHeight = header.offsetHeight;

  window.addEventListener("scroll", function () {
    // scrolled is new position just obtained
    var scrolled = document.documentElement.scrollTop || document.body.scrollTop;

    // optionally emulate non-fixed positioning behaviour
    if (scrolled > headerHeight) {
      header.classList.add("off-canvas");
    } else {
      header.classList.remove("off-canvas");
    }

    if (scrolled > scroll) {
      // scrolling down
      header.classList.remove("fixed");
    } else {
      //scrolling up
      header.classList.add("fixed");
    }

    scroll = scrolled;
  });
});




















(function() {
  var Flip;

  Flip = class Flip {
    constructor(el) {
      this.el = el;
      this.el = $(this.el);
      this.currentStep = 0;
      console.log("Created new Flip");
      $('.next').on('click', $.proxy(this.next, this));
    }

    next(event) {
      var currentStepEl, nextStepEl, nextStepNum;
      if (event) {
        event.preventDefault();
      }
      nextStepNum = this.currentStep + 1;
      currentStepEl = this.el.find(`.step${this.currentStep}`);
      nextStepEl = this.el.find(`.step${nextStepNum}`);
      if (nextStepEl.length) {
        console.log('we found the next step', nextStepEl);
        currentStepEl.prev().removeClass('down');
        currentStepEl.removeClass('set');
        currentStepEl.addClass('down');
        nextStepEl.addClass('set');
        nextStepEl.removeClass('down');
        nextStepEl.next().removeClass('down');
        return this.currentStep++;
      } else {
        // reset to 0
        this.el.find(".step").removeClass('set');
        this.el.find(`.step${this.currentStep}`).addClass('down');
        this.el.find(".step").not(`.step${this.currentStep}`).removeClass('down');
        this.currentStep = -1;
        return this.next();
      }
    }

  };

  (function() {
    var f;
    f = new Flip(document.getElementById('flipper'));
    return setInterval((function() {
      return f.next();
    }), 2500);
  });

}).call(this);



